import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { ApartmentOutlined } from '@ant-design/icons';
import './BotFlow.css';

const BotFlowModule = () => {
  const isBuilderRoute = useMatch('/dashboard/bot-flow/:flowId');

  return (
    <div className={`botflow-module${isBuilderRoute ? ' botflow-module--builder' : ''}`}>
      {!isBuilderRoute && (
        <div className="botflow-header">
          <h2><ApartmentOutlined /> Bot Flow Builder</h2>
        </div>
      )}
      <div className="botflow-content">
        <Outlet />
      </div>
    </div>
  );
};

export default BotFlowModule;
